var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "member-review-status"
  }, [_c('div', {
    staticClass: "member-review-status-card"
  }, [_c('h2', [_vm._v("This link has expired")]), _c('p', [_vm._v("Your review session has ended or the link is no longer valid. Please open the link from your email or text message again.")])])]);

}]

export { render, staticRenderFns }